module.exports = __webpack_public_path__ + "img/Logo-icon.90b34ac5.svg";